module.exports = __webpack_public_path__ + "img/user-persona-mobile.297e88c7.png";